module.exports = __webpack_public_path__ + "static/media/6C.5c96f40f.png";